import "./styles.scss"
import { Modal, Image, Container } from "react-bootstrap"
import PropTypes from "prop-types"
import React from "react"
import ETETECHNOLOGY_LOGO from "../../../assets/images/EteTechnology_LOGO_YATAY.png"
import CUBES from "../../../assets/images/careerDetailCubes.png"

const QualityControlModal = ({ onHide, showModal, state, getLanguageFile }) => {
  return (
    <Modal
      show={showModal}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {" "}
      <Container fluid className="about-us-image-container">
        <Image className={"about-us-image-background"} src={CUBES} />
      </Container>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ padding: "0 4em" }}>
        <Image
          src={ETETECHNOLOGY_LOGO}
          style={{ width: "45%", display: "block" }}
        ></Image>

        <h4 className="modal-sub-title">
          {getLanguageFile(state.language).QualityControl.title}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).QualityControl.description}
        </p>
        <ul>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemOne}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemTwo}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemThree}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemFour}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemFive}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemSix}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemSeven}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemEight}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemNine}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).QualityControl.listItemTen}
            </p>
          </li>
        </ul>

        <p className="description">
          {getLanguageFile(state.language).QualityControl.finishText}
        </p>
        <p className="description">
          {getLanguageFile(state.language).QualityControl.name}
          <br />
          {getLanguageFile(state.language).QualityControl.position}
        </p>
        <div className="borderBottom"></div>
        <div className="tags">
          <p>
            <strong>
              {getLanguageFile(state.language).QualityControl.documentCode}
            </strong>{" "}
            PLT_01
          </p>
          <p>
            <strong>
              {getLanguageFile(state.language).QualityControl.issueDate}
            </strong>{" "}
            28.02.2025
          </p>
          <p>
            <strong>
              {getLanguageFile(state.language).QualityControl.revisionCode}
            </strong>{" "}
            00
          </p>
          <p>
            <strong>
              {getLanguageFile(state.language).QualityControl.revisionDate}
            </strong>{" "}
            ---
          </p>
        </div>
      </Modal.Body>
    </Modal>
  )
}

QualityControlModal.propTypes = {
  showModal: PropTypes.boolean,
  onHide: PropTypes.any,
  state: PropTypes.any,
  getLanguageFile: PropTypes.any,
}

QualityControlModal.defaultProps = {
  showModal: false,
}

export default QualityControlModal
